import { Form, InputNumber } from 'antd';
import React from 'react';
import { FormInstance } from 'antd/lib/form/Form';
import styled from 'styled-components';

import { TMaintenanceService } from '../start-work-order/type';
import { AutoTrackForm } from '../../components/form/form';
import { AutoTrackInput } from '../../components/form/input';

const Wrapper = styled.div`
    .ant-row {
        align-items: center;
    }
    .ant-form-item-has-error {
        .ant-row {
            align-items: flex-start;
        }
    }
`;

type ServiceFormProps = {
    serviceData: TMaintenanceService | undefined;
    form: FormInstance;
};
export const ServiceForm: React.FC<ServiceFormProps> = ({
    serviceData,
    form,
}) => {
    const childForm = (
        <div className="grid gap-[10px] grid-cols-[1fr] max-md:p-[10px]">
            <Form.Item
                name="serviceName"
                label="Service Name"
                rules={[
                    {
                        required: true,
                        message: 'Please input the service name!',
                    },
                ]}
            >
                <AutoTrackInput isRequired={true} />
            </Form.Item>
            <Form.Item
                name="interval"
                label="Interval"
                rules={[
                    {
                        required: true,
                        message: 'Please input the interval!',
                    },
                ]}
            >
                <AutoTrackInput
                    isRequired={true}
                    placeholder="e.g. 5,000-7,500 miles"
                />
            </Form.Item>
            <Form.Item
                name="estimatedPriceMin"
                label="Est. Price Min ($)"
                rules={[
                    {
                        required: true,
                        message: 'Please input the minimum estimated price!',
                    },
                ]}
            >
                <InputNumber
                    min={0}
                    size="large"
                    style={{ width: '100%' }}
                    formatter={value =>
                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                />
            </Form.Item>
            <Form.Item
                name="estimatedPriceMax"
                label="Est. Price Max ($)"
                rules={[
                    {
                        required: true,
                        message: 'Please input the maximum estimated price!',
                    },
                ]}
            >
                <InputNumber
                    min={0}
                    size="large"
                    style={{ width: '100%' }}
                    formatter={value =>
                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                />
            </Form.Item>
            <Form.Item name="estimatedTime" label="Est. Time">
                <AutoTrackInput placeholder="e.g. 30-60 mins" />
            </Form.Item>
        </div>
    );

    React.useEffect(() => {
        if (serviceData) {
            form.setFieldsValue({
                serviceName: serviceData.serviceName,
                interval: serviceData.interval,
                estimatedPriceMin: serviceData.estimatedPriceMin,
                estimatedPriceMax: serviceData.estimatedPriceMax,
                estimatedTime: serviceData.estimatedTime,
            });
        }
    }, [serviceData, form]);

    return (
        <Wrapper className="flex flex-col gap-[20px] w-full overflow-hidden h-full items-start box-border py-[20px] px-[5px] max-md:p-0">
            <AutoTrackForm
                labelCol={{ flex: '150px' }}
                labelAlign="left"
                form={form}
                labelWrap
                wrapperCol={{ flex: 1 }}
                layout="horizontal"
                className="w-full"
                name="createService"
                childNode={childForm}
            />
        </Wrapper>
    );
};
